import React from 'react';
import { Redirect } from 'react-router';
import { LoginContainerDiv, LoginContainerDivProps } from '../../Shared/Styled';
import { LoginButton, LoginButtonProps } from './LoginButton';
import { LoginIntroduction } from './LoginIntroduction';
import { LoginFooter } from './LoginFooter';
import { defaultFont } from '../../../styles/SharedStyles';
import { useThemeContext } from '../../../context/themeContext';
import { User } from 'oidc-client';

export interface LoginRenderProps {
  LoginContainerDiv: React.FC<LoginContainerDivProps>;
  LoginIntroduction: React.FC;
  LoginButton: React.FC<LoginButtonProps>;
  LoginFooter: React.FC;
}

export interface LoginProps {
  referrer?: string;
  loggingIn: boolean;
  user?: User;
  pwdiUser?: User;
  login: () => any;
  render?: (LoginRenderProps: LoginRenderProps) => any;
}

export function Login({
  referrer,
  loggingIn,
  user,
  pwdiUser,
  login,
  render,
}: LoginProps): JSX.Element {
  const theme = useThemeContext();
  return render ? (
    render({
      LoginContainerDiv,
      LoginIntroduction,
      LoginButton,
      LoginFooter,
    })
  ) : (
    <LoginContainerDiv themeStr={theme}>
      {referrer ? (
        <>
          {loggingIn ? (
            <p style={defaultFont}>Please sign in using the pop-up window.</p>
          ) : user && pwdiUser ? (
            <Redirect to={referrer} />
          ) : (
            <LoginContent login={login} />
          )}
        </>
      ) : null}
    </LoginContainerDiv>
  );
}

const LoginContent = ({ login }) => (
  <>
    <LoginIntroduction />
    <LoginButton onClick={login} buttonText={'Sign in'} />
    <LoginFooter />
  </>
);
